import { usePWA } from "../hooks/usePWA";
import styles from "./PWABadge.module.css";

/**
 * PWABadge
 * Shows:
 *  1. An "Install App" banner when the browser fires beforeinstallprompt
 *  2. A slim "You're offline" bar when navigator.onLine is false
 *
 * Drop this anywhere in App.jsx — it manages its own visibility.
 */
export default function PWABadge() {
  const { isInstallable, isInstalled, isOffline, installApp } = usePWA();

  return (
    <>
      {/* ── Offline indicator ── */}
      {isOffline && (
        <div className={styles.offlineBar} role="alert">
          <span className={styles.offlineDot} />
          You're offline — some content may be unavailable
        </div>
      )}

      {/* ── Install prompt banner ── */}
      {isInstallable && !isInstalled && (
        <div className={styles.installBanner}>
          <div className={styles.installLeft}>
            <span className={styles.installIcon}>🧁</span>
            <div>
              <p className={styles.installTitle}>Add to Home Screen</p>
              <p className={styles.installSub}>
                Get the full app experience — works offline too
              </p>
            </div>
          </div>
          <div className={styles.installActions}>
            <button className={styles.installBtn} onClick={installApp}>
              Install ✦
            </button>
          </div>
        </div>
      )}
    </>
  );
}
